function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hex-global_svg__clip0_2_285)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.218,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.787.625l34.31 19.81v39.618l-34.31 19.809-34.31-19.81V20.435L34.786.625z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.343,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.783 5.47L73.3 22.423v33.91L43.783 73.287 14.267 56.333v-33.91L43.783 5.47z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.856 10.66l25.62 14.791v29.584l-25.62 14.792-25.62-14.792V25.451l25.62-14.792z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.164 25C47.41 25 41.1 31.449 41.1 39.375S47.41 53.75 55.164 53.75c7.754 0 14.062-6.449 14.062-14.375S62.918 25 55.164 25zm12.528 14.375c0 1.233-.172 2.426-.491 3.556H61.98c.114-1.165.179-2.357.179-3.55 0-1.192-.065-2.384-.18-3.549h5.225c.318 1.126.488 2.314.488 3.543zm-1.132-5.317h-4.797c-.379-2.503-1.031-4.796-1.945-6.573 2.986 1.226 5.407 3.594 6.742 6.573zm-6.143 5.324c0 1.23-.065 2.412-.179 3.549H50.185a35.537 35.537 0 01-.178-3.55c0-1.23.065-2.412.178-3.549h10.053c.114 1.137.18 2.319.18 3.55zm-3.14-12.631c1.232 1.406 2.219 4.034 2.739 7.307h-9.603c.523-3.289 1.517-5.926 2.758-7.327a12.306 12.306 0 014.105.02zm-6.646.685c-.927 1.784-1.587 4.096-1.965 6.622h-4.898c1.353-3.02 3.821-5.411 6.863-6.622zM48.444 42.93h-5.317a13.033 13.033 0 01-.492-3.556c0-1.229.17-2.417.488-3.543h5.326a36.55 36.55 0 00-.179 3.55c0 1.192.065 2.384.174 3.549zm-4.67 1.775h4.892c.382 2.519 1.04 4.826 1.963 6.607-3.036-1.209-5.501-3.595-6.855-6.607zm9.383 7.31c-1.234-1.404-2.223-4.033-2.744-7.31h9.603c-.518 3.26-1.5 5.88-2.727 7.29a12.286 12.286 0 01-4.132.02zm6.677-.758c.908-1.774 1.557-4.059 1.934-6.552h4.786c-1.334 2.967-3.746 5.327-6.72 6.552z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hex-global_svg__clip0_2_285"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.476)",
  d: "M0 0h80v80H0z"
})));

function SvgHexGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgHexGlobal;